var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error401 d-flex align-items-center h-100 flex-column justify-content-center"},[_c('div',{staticClass:"error404-center"},[_c('h1',[_vm._v("Napaka 401")]),_c('p',[_vm._v("Dostop do želene strani žal ni dovoljen.")]),_c('router-link',{attrs:{"to":{name: 'home'}}},[_vm._v("Nazaj na prvo stran")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }